export const RESET_STATE = 'RESET_STATE';

export const LISTAGEM_PEDIDO_LOADING = 'LISTAGEM_PEDIDO_LOADING';
export const LISTAGEM_PEDIDO = 'LISTAGEM_PEDIDO';
export const LISTAGEM_PEDIDO_ERRO = 'LISTAGEM_PEDIDO_ERRO';

export const DETALHAMENTO_PEDIDO_LOADING = 'DETALHAMENTO_PEDIDO_LOADING';
export const DETALHAMENTO_PEDIDO = 'DETALHAMENTO_PEDIDO';
export const DETALHAMENTO_PEDIDO_ERRO = 'DETALHAMENTO_PEDIDO_ERRO';